import * as React from "react";
import * as Ons from "react-onsenui";
import ReactSignatureCanvas from "react-signature-canvas";
import { If } from "./Generic/If";

interface SignatureProps {
  initialData: string | null;
  className?: string;
  width?: number;
  height?: number;
  buttonClassName?: string;
  label?: string;
  onEnd: (dataURL: string | null) => void;
  onClear?: () => void;
}

interface SignatureState {
  showPlaceholder: boolean;
}

export class Signature extends React.Component<SignatureProps, SignatureState> {
  constructor(props: SignatureProps) {
    super(props);

    this.state = {
      showPlaceholder: this.props.initialData === null,
    };
  }

  shouldComponentUpdate(nextProps: SignatureProps, nextState: SignatureState) {
    return (
      nextProps.initialData !== this.props.initialData ||
      nextProps.className !== this.props.className ||
      nextProps.width !== this.props.width ||
      nextProps.height !== this.props.height ||
      nextProps.buttonClassName !== this.props.buttonClassName ||
      nextProps.label !== this.props.label ||
      nextState.showPlaceholder !== this.state.showPlaceholder
    );
  }

  componentDidMount() {
    if (this.props.initialData !== null) {
      const tempImage = new Image();

      tempImage.onload = () => {
        this.signature.clear();
        this.signature.getCanvas().getContext("2d").drawImage(tempImage, 0, 0);
      };

      tempImage.src = this.props.initialData;
    } else {
      this.signature.clear();
    }
  }

  signature: any = null;
  lastSignatureURL: string | null = null;

  handleChange = () => {
    const newSignature = this.signature.isEmpty() ? null : this.signature.getCanvas().toDataURL();
    if (newSignature !== this.lastSignatureURL) {
      this.lastSignatureURL = newSignature;
      this.props.onEnd(this.lastSignatureURL);
    }
  };

  onClickReset() {
    this.signature.clear();
    this.handleChange();

    if (this.props.onClear !== undefined) {
      this.props.onClear();
    }
  }

  render() {
    const HEIGHT = this.props.height !== undefined ? this.props.height : 250;
    const WIDTH = this.props.width !== undefined ? this.props.width : 300;
    return (
      <>
        <div className="Signature__root">
          <div className="Signature__CanvasContainer">
            <If condition={this.state.showPlaceholder}>
              <div className="Signature__Placeholder">
                <img src="assets/sign-placeholder.svg" alt="sign-placeholder" />
                <span>Sign Here</span>
              </div>
            </If>
            <ReactSignatureCanvas
              clearOnResize={false}
              canvasProps={{
                width: WIDTH,
                height: HEIGHT,
                className:
                  "Signature__canvas " +
                  (this.props.className !== undefined ? this.props.className : ""),
              }}
              ref={(e: any) => (this.signature = e)}
              onBegin={() => this.setState({ showPlaceholder: false })}
              onEnd={() => this.handleChange()}
            />
          </div>

          <If condition={this.props.label !== undefined}>
            <span style={{ color: "rgba(0, 0, 0, 0)", marginTop: 3 }}>{this.props.label}</span>
          </If>

          <If condition={this.props.onClear === undefined}>
            <div className={"Signature__buttonContainer"}>
              <Ons.Button
                modifier="outline"
                ripple={true}
                className={
                  "btn btn-default btn-sm " +
                  (this.props.buttonClassName !== undefined ? this.props.buttonClassName : "")
                }
                onClick={() => {
                  this.signature.clear();
                  this.handleChange();
                  if (this.props.onClear !== undefined) {
                    this.props.onClear();
                  }
                }}
              >
                Clear
              </Ons.Button>
            </div>
          </If>
        </div>
      </>
    );
  }
}
